import cn from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { PromotionParameterDto } from '../../../api/common.generated';
import { DSRadio } from '../../../designSystem';
import Marquee from '../../../shared/components/Marquee/Marquee';
import { formatDate } from '../../../shared/util/utility';
import { PromotionListItemType } from '../PromotionPicker.types';

export const PromotionListItem = memo(({ styles, selectedPromotionId, onSelect, promotion }: PromotionListItemType) => {
	const { t } = useTranslation();
	const promotionDateTill = () => {
		return promotion.registrationDateTill
			? t('regPromotionPickerPromotionAvailableTo') + ' ' + formatDate(promotion.registrationDateTill, 'YYYY-MM-DD HH:mm')
			: t('regPromotionPickerPromotionAvailable');
	};
	const selectPromotion = () => {
		onSelect(promotion.promotionId);
	};
	const parameterItem = (param: PromotionParameterDto, index: number) => (
		<div key={index} className={cn('text-paragraph-xs flex gap-1', styles.textBlackColor)}>
			{param.icon && <img src={param.icon} className="w-3" />}
			<div className="">
				<span className="font-semibold">{param.name}:</span> {param.value}{' '}
			</div>
		</div>
	);
	return (
		<div onClick={selectPromotion} className={cn('cursor-pointer rounded-8 p-2 mb-2 relative', styles.promotionCard)}>
			<div className="absolute top-0 right-0 m-2">
				<DSRadio color={styles.inputColor} enabled={selectedPromotionId === promotion.promotionId} />
			</div>
			<div className={cn('table mr-10 text-white text-paragraph-sm font-semibold bg-success-600 rounded-2 py-0.5 px-2')}>
				{promotion.promotionName}
			</div>
			<div className={cn('text-paragraph-xs font-semibold mt-2 mb-3', styles.textColor)}>
				<Marquee className={styles.marquee} text={promotion.summary as string} />
			</div>
			<div className="flex flex-col gap-2 mx-1">{promotion.parameters.map(parameterItem)}</div>
			<div className={cn('text-paragraph-xs  mt-2 tracking-widest', styles.textGrayColor)}>{promotionDateTill()}</div>
		</div>
	);
});
